const apiurl = localStorage.getItem(localStorage.getItem('appPrefix') + 'apiurl');

export default apiurl